import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import FormGroup from "../../components/form-group";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useAttachmentService} from "../../services/attachment-service";
import {attachmentRequestSchema, newAttachmentsRequestSchema} from "../../utils/schemas";
import {AttachmentTypes} from "../../utils/constants";
import Fileupload from "../../components/files/fileupload";

const AddEditAttachmentModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [files, setFiles] = useState([]);
  const [filesData, setFilesData] = useState([]);
  const [attachmentTypes, setAttachmentTypes] = useState([]);
  const [attachmentCategories, setAttachmentCategories] = useState([]);
  const [reset, setReset] = useState(0);

  let formSchema = newAttachmentsRequestSchema;

  let attachmentService = useAttachmentService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null, allowedAttachmentTypes=[], allowedAttachmentCategories=[]) => {
    setLoading(true);
    setFiles([]);
    setAttachmentTypes(allowedAttachmentTypes)
    setAttachmentCategories(allowedAttachmentCategories)

    if (model && model.id){
      formSchema = attachmentRequestSchema;
      let promises = [
        Promise.resolve('initOk'),
        getDetail(model.id)
      ];
      Promise.all(promises).then(([initOk, detail= {}])=>{
        let newDetail = Object.assign({}, {attachment_type_id: allowedAttachmentTypes ? allowedAttachmentTypes[0].val : AttachmentTypes.document.val, description: ''}, detail);
        setModel(formSchema.cast(newDetail));
        setLoading(false);
      });
    } else {
      formSchema = newAttachmentsRequestSchema;
      setModel(formSchema.cast());
      setLoading(false);
    }

    setShow(true);
  }
  const closeModal = () => {
    setShow(false);
    setReset(reset+1);
    setModel(formSchema.cast());
  }

  const getDetail = (id) => {
    return attachmentService.getDetail(id);
  }

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};

    attachmentService.addEditModel(reqValues, reqValues.id)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        setFiles([]);
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        key={reset}
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue}) => (

          <Modal size={model?.id ? 'md' : 'xl'} show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>{ !model.id ? 'Nová príloha' : 'Úprava prílohy' }</Modal.Title>}
            </Modal.Header>
            <Modal.Body>

              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && model?.id && <Form className="row">

                  <FormGroup
                    name="title"
                    placeholder="Názov"
                    label="Názov"
                    className="col-md-12"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  {attachmentTypes && attachmentTypes.length>0 && <FormGroup
                    name="attachment_type_id"
                    type="select"
                    options={Object.values(attachmentTypes)}
                    optionLabel="title"
                    optionKey="val"
                    placeholder="typ"
                    label="Typ"
                    className="col-md-6"
                    touched={touched} errors={errors} schema={formSchema}
                  />}

                  {attachmentCategories && attachmentCategories.length>0 && <FormGroup
                    name="attachment_category_id"
                    type="select"
                    options={attachmentCategories}
                    optionLabel="title"
                    optionKey="id"
                    placeholder="Kategória"
                    label="Kategória"
                    className="col-md-6"
                    touched={touched} errors={errors} schema={formSchema}
                  />}

                  <FormGroup
                    name="description"
                    placeholder="Popis"
                    label="Popis"
                    className="col-md-12"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="clearfix"></div>

                </Form>}

                {!loading && !model?.id && <Form className="row">

                  <div className="col-sm-12" key="mediadocsection">
                    <h5>Médiá a dokumenty</h5>
                    <p className='text-muted'>Pridajte hlavný obrázok, galériu k článku alebo dokumenty na stiahnutie.</p>
                    <Fileupload attachmentTypes={Object.values(attachmentTypes)}
                                attachmentCategories={attachmentCategories}
                                files={files}
                                filesData={filesData}
                                cardClass={'col-sm-12 col-md-6'}
                                onChange={({files, filesData})=>{setFiles(files); setFilesData(filesData)}}
                                setFieldValue={setFieldValue} />
                  </div>

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default AddEditAttachmentModal;
